import { render, staticRenderFns } from "./SalesReportsPageHeader.vue?vue&type=template&id=35dcb116&scoped=true"
import script from "./SalesReportsPageHeader.vue?vue&type=script&lang=js"
export * from "./SalesReportsPageHeader.vue?vue&type=script&lang=js"
import style0 from "./SalesReportsPageHeader.vue?vue&type=style&index=0&id=35dcb116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dcb116",
  null
  
)

export default component.exports